import React from 'react';
import {
    Switch,
    Route,
    Redirect,
    HashRouter
  } from 'react-router-dom';

import InfoSocio from './views/InfoSocio';
import LoginView from './views/LoginView';
import RegistroView from './views/registro/RegistroView';
import RecuperoView from './views/recupero/RecuperoView';
import RecuperoTokenView from './views/recupero/RecuperoTokenView';

import { useAuth } from './context/authContext';
import DefaultLayout from './views/containers/DefaultLayout';
import SolicitarEmail from './views/registro/SolitarEmail';
import ModificarEmail from './views/registro/ModificarEmail';

const App = () => {
  const { loggedIn } = useAuth();

  function PrivateRoute({ children, ...rest }) {
    return (
      <Route
        {...rest}
        render={() => {
          return loggedIn ? children : <Redirect to="/" />;
        }}
      />
    );
  }
    return (
      <DefaultLayout>
        <HashRouter>
          <Switch>
            <Route path="/" exact>
              <LoginView />
            </Route>
            <Route path="/registro" exact>
              <RegistroView />
            </Route>
            <Route path="/recupero" exact>
              <RecuperoView />
            </Route>
            <Route path="/recupero/token" exact>
              <RecuperoTokenView />
            </Route>
            <Route path="/modificar-email" exact>
              <ModificarEmail />
            </Route>
            <PrivateRoute path="/solicitarmail" exact>
              <SolicitarEmail />
            </PrivateRoute>
            <PrivateRoute path="/infosocio" exact>
              <InfoSocio />
            </PrivateRoute>
            <Redirect to="/" />
          </Switch>
        </HashRouter>
      </DefaultLayout>
    )
}

export default App;